"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    padding: 0.2rem 0.8rem;\n    color: var(--blue);\n    font-size: var(--font-size-small-0);\n    border: var(--border-light-2);\n    background: var(--light-blue);\n    margin-bottom: 1rem;\n    transition: all .2s;\n\n    @media (min-width: calc(", " + 1px)) {\n      &:not(:first-child) {\n        margin-left: 1rem;\n      }\n    }\n\n    @media(max-width: ", ") {\n      &:not(:last-child) {\n        margin-right: 1rem;\n      }\n    }\n\n    &:hover,\n    &:focus {\n      background: var(--blue-0);\n      color: var(--white);\n      text-decoration: none;\n    }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const gatsby_1 = require("gatsby");
const variables_1 = require("../styles/variables");
const helpers_1 = require("../utils/helpers");
var StyledTag = styled_1.default(gatsby_1.Link)(_templateObject(), variables_1.breakpoints.large, variables_1.breakpoints.large);
var Tag = function Tag(_ref) {
    var text = _ref.text, styles = _ref.styles;
    return /*#__PURE__*/ react_1.default.createElement(StyledTag, {
        to: "/" + helpers_1.hyphenate(text),
        state: {
            name: 'text'
        },
        style: Object.assign({}, styles)
    }, text);
};
exports.default = Tag;
